module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/btn-english-download.7fef6f1d.png";